import React from 'react';

import "./QuestionList.css";

const QuestionListMultipleChoice = ({clsHidden, draftActiveProject, questionIndex, handleQuestionInputChange, handleQuestionOptionsChange}) => {

  return (
    <div className={`form-question-section ${clsHidden}`}>
      <div className="form-row">
        <div className="form-group col-12">
          <label className="form-label" htmlFor="js-form-multiple-choice-question">Question</label>

          <input
            type="text"
            className="form-control form-input"
            id="js-form-multiple-choice-question"
            placeholder="e.g: What is your favourite programming language?"
            name="description"
            value={draftActiveProject.questions[questionIndex].description}
            onChange={handleQuestionInputChange(questionIndex)}
          >
          </input>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="js-form-answer1">Answer 1</label>

          <input
            type="text"
            className="form-control form-input"
            id="js-form-answer1"
            placeholder="e.g: JavaScript"
            name="options"
            value={draftActiveProject.questions[questionIndex].options[0]}
            onChange={handleQuestionOptionsChange(questionIndex, 0)}
          >
          </input>
        </div>

        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="js-form-answer2">Answer 2</label>

          <input
            type="text"
            className="form-control form-input"
            id="js-form-answer2"
            placeholder="e.g: Java"
            name="options"
            value={draftActiveProject.questions[questionIndex].options[1]}
            onChange={handleQuestionOptionsChange(questionIndex, 1)}
          >
          </input>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="js-form-answer3">Answer 3</label>

          <input
            type="text"
            className="form-control form-input"
            id="js-form-answer3"
            placeholder="e.g: Python"
            name="options"
            value={draftActiveProject.questions[questionIndex].options[2]}
            onChange={handleQuestionOptionsChange(questionIndex, 2)}
          >
          </input>
        </div>

        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="js-form-answer4">Answer 4</label>

          <input
            type="text"
            className="form-control form-input"
            id="js-form-answer4"
            placeholder="e.g: C++"
            name="options"
            value={draftActiveProject.questions[questionIndex].options[3]}
            onChange={handleQuestionOptionsChange(questionIndex, 3)}
          >
          </input>
        </div>
      </div>
    </div>
  )
}

export default QuestionListMultipleChoice;
